<template>
	<AppMore :appMore="appMore"> </AppMore>
</template>
<script>
import AppMore from '../../../../components/base/AppMore'
export default {
	props: {
		appMore: {
			type: Array,
			required: true,
		},
	},
	components: {
		AppMore,
	},
}
</script>

<style lang="scss">
.adguard-landing-more {
	.block-content {
		.block-use {
			&.nutstore1 {
				li:nth-child(1) {
					background-image: url('./adguard_1_icon.svg');
				}
				li:nth-child(2) {
					background-image: url('./adguard_2_icon.svg');
				}
				li:nth-child(3) {
					background-image: url('./adguard_3_icon.svg');
				}
			}
			&.nutstore2 {
				li:nth-child(1) {
					background-image: url('./adguard_4_icon.svg');
				}
				li:nth-child(2) {
					background-image: url('./adguard_5_icon.svg');
				}
				li:nth-child(3) {
					background-image: url('./adguard_6_icon.svg');
				}
			}
		}
	}
}
</style>
